import { TaxiCarApiTaxiCarListRequest } from "../../openapi";
import appApiClient from "./coreApiClient";
import useBaseQuery from "./useBaseQuery";

export const useTaxiCarListQuery = (req: TaxiCarApiTaxiCarListRequest) =>
  useBaseQuery({
    queryKey: ["taxiCarList", req],
    queryFn: (config) => appApiClient.taxiCarApi.taxiCarList(req, config),
  });
